module.exports = __webpack_public_path__ + "static/media/solution-2-big.f57195e5.png";